import React from "react";
import { withRouter } from "react-router-dom";
import TableComponent, { TableOp } from "../../../components/table/TableOps";
import { Button } from "@material-ui/core";
import ACCESS from "../../../ACCESS";

class Cotizaciones extends TableComponent {

  componentDidMount() {
    this.tableConfig(
      { dataUrl: 'cotizacion/filter', deleteUrl: 'cotizacion/delete', deleteField: 'cliente_nombre', modUrl: '/Catalogo/Cotizacion' },
      TableOp.Table(null, [
        { label: 'Cliente', id: 'cliente' },
        { label: 'Origen', id: 'origen' },
        { label: 'Destino', id: 'destino' },
        { label: 'Usuario', id: 'usuario' },
        { label: 'Fecha', id: 'createdAt' },
      ], [
        { id: 'edit', icon: 'edit', 
          access: [ACCESS.VENTAS_COTIZACIONES.VER_COTIZACIONES_CREADAS_POR_EL_USUARIO, ACCESS.VENTAS_COTIZACIONES.VER_COTIZACIONES_SUCURSAL_DEL_USUARIO,
            ACCESS.VENTAS_COTIZACIONES.VER_TODAS_COTIZACIONES
          ] },
      ]))
    this.table();
  }

  render() {
    const { hasAccess } = this.context;
    return (
      <div>
        <div
          style={{
            display: "flex",
            padding: 10,
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h1>Cotizaciones</h1>
          {
            hasAccess(ACCESS.VENTAS_COTIZACIONES.CREAR_COTIZACION) &&
            <Button
              color="primary"
              variant={"contained"}
              onClick={() => {
                this.props.history.push(`/Ventas/Cotizacion`);
              }}
            >
              Nueva Cotizacion
            </Button>
          }
        </div>
        <this.TableRender />
      </div>
    );
  }
}


export default withRouter(Cotizaciones)